import { render, staticRenderFns } from "./ProductsOverview.vue?vue&type=template&id=544b75f7&"
import script from "./ProductsOverview.vue?vue&type=script&lang=js&"
export * from "./ProductsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports